import { books } from 'assets';
import GiftAnimation from 'assets/Animations/GiftAnimation';
import BooksIcon from 'assets/Icons/OrderSuccessful/BooksIcon';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';
import { BiBookAlt, BiChevronsUp, BiPlus, BiTimer } from 'react-icons/bi';
import { twMerge } from 'tailwind-merge';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

import { FormattedFinalOrder } from '@/utils/interfaces/Orders';
import {
  IPlansOffer,
  IStartSubscriptionBody,
  Product,
} from '@/utils/interfaces/Subscription';

interface Props {
  productsArray?: any[];
  plansOfferData: IPlansOffer | undefined;
  array: number;
  loadingSb: boolean;
  handleSubscribe: (data: IStartSubscriptionBody) => Promise<void>;
  formatTime: (seconds: number) => string;
  time: number;
  limitedProducts: Product[];
  remainingCount: number;
}
interface Props3 {
  order: FormattedFinalOrder | undefined;
}

export const Item: FC<Props> = ({
  array,
  plansOfferData,
  loadingSb,
  handleSubscribe,
  formatTime,
  time,
  limitedProducts,
  remainingCount,
}) => {
  return (
    <div className='bg-cardBg sm:px-10 px-4 sm:py-5 py-4 rounded-2xl flex flex-col items-center'>
      <GiftAnimation className='sm:w-20 w-14 sm:h-20 h-14 sm:mb-5 mb-[17px]' />
      <div className='flex flex-col items-center sm:mb-5 mb-[22px]'>
        <p className='sm:text-2xl text-xl/8  text-center font-bold text-white sm:mb-0 mb-0.5'>
          Upgrade your order
        </p>
        <p className='sm:text-base text-sm/6 text-grayZl-500 text-center'>
          Become a ZebraLearn Prime Member
        </p>
      </div>
      <div className='flex items-center gap-1 flex-nowrap max-w-full overflow-x-auto hide-scrollbar justify-center sm:mb-6 mb-[22px]'>
        <div className='flex items-center gap-1 flex-nowrap w-full '>
          {limitedProducts?.map((i, index) => (
            <>
              <div className='flex items-center justify-center min-w-[70px] min-h-[100px] w-[70px] h-[100px] bg-cover rounded-2xl bg-white/5 border border-white/20 border-dashed overflow-hidden'>
                {i?.thumbnail_image ? (
                  <Image
                    key={index}
                    className='w-full h-full'
                    alt='book'
                    src={i?.thumbnail_image || ''}
                    width={70}
                    height={100}
                  />
                ) : (
                  <BiBookAlt className='text-grayZl-600 w-5 h-5' />
                )}
              </div>
              {limitedProducts.length - 1 === index ? (
                <></>
              ) : (
                <BiPlus className='w-6 h-6 min-w-6 min-h-6  text-grayZl-600' />
              )}
            </>
          ))}
          {remainingCount ? (
            <div className='flex items-center gap-1'>
              <BiPlus className='w-6 h-6 min-w-6 min-h-6  text-grayZl-600' />
              <div className='flex items-center justify-center min-w-[70px] min-h-[100px] w-[70px] h-[100px] bg-cover rounded-2xl bg-white/5 border border-white/20 border-dashed overflow-hidden'>
                {remainingCount && remainingCount === 1 ? (
                  <BiBookAlt className='text-grayZl-600 w-5 h-5' />
                ) : (
                  <>
                    {' '}
                    <BiPlus className='text-grayZl-600 w-4 h-4' />
                    <p className='text-grayZl-600 text-base font-semibold'>
                      {remainingCount}
                    </p>
                  </>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <p className='sm:text-2xl text-xl/8 font-semibold text-white text-center capitalize sm:mb-10 mb-[25px]'>
        Choose any {array} additional{' '}
        {plansOfferData?.plan?.details?.rules?.[0]?.physical
          ? 'Hard'
          : 'Digital'}{' '}
        Cover Books at ₹{plansOfferData?.plan.plan_discounted_price} 😱
      </p>

      <ButtonDefault
        disabled={loadingSb}
        loading={loadingSb}
        onClick={() =>
          handleSubscribe({
            plan_id: plansOfferData?.plan.id || 0,
            change: true,
            immediate: true,
            discount: true,
            order_id: plansOfferData?.order.id,
          })
        }
        size={0}
        className='sm:py-3 py-[7px] px-8 sm:text-base text-sm/6 w-full sm:rounded-xl rounded-lg'
        variant={ButtonVariants.PRIMARY}
      >
        {!loadingSb ? <BiChevronsUp className='w-6 h-6' /> : <></>}
        Upgrade For ₹{plansOfferData?.plan.plan_discounted_price}
      </ButtonDefault>
      <div className='absolute top-0 left-0 sm:m-5 m-4'>
        {time > 0 ? (
          <div className='sm:px-2 px-1.5 sm:py-0.5 py-[5px] flex items-center gap-1 bg-grayZl-500 sm:rounded-[10px] rounded self-center'>
            <BiTimer className='sm:w-5 w-2.5 sm:h-5 h-2.5 text-black' />
            <p className='sm:text-[13px] text-[9px] sm:leading-6 leading-[100%] text-black'>
              Offer Expiring in
            </p>
            <p className='sm:text-[13px] text-[9px] sm:leading-6 leading-[100%] text-black font-semibold'>
              {formatTime(time)}
            </p>
          </div>
        ) : (
          <div className='sm:px-2 px-1.5 sm:py-0.5 py-[5px] flex items-center gap-1 bg-grayZl-500 sm:rounded-[10px] rounded self-center'>
            <p className='sm:text-[13px] text-[9px] sm:leading-6 leading-[100%] text-black'>
              Offer Ended
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
export const Item2 = () => {
  return (
    <div className='bg-cardBg sm:px-10 px-4 sm:py-5 py-4 rounded-2xl flex flex-col items-center'>
      <BooksIcon className='sm:w-[60px] w-[48px] sm:h-[60px] h-[48px] sm:mb-[18px] mb-[17px]' />
      <div className='flex flex-col items-center sm:mb-[25px] mb-[19px]'>
        <p className='sm:text-2xl text-xl/8 text-center font-bold text-white'>
          Buying for a team or institution?
        </p>
        <p className='sm:text-base text-sm/6 text-grayZl-500 text-center'>
          Save more on bulk & library orders
        </p>
      </div>
      <div className='sm:py-3 py-2.5 sm:px-1.5 px-1 bg-grayZl-950 rounded-lg sm:mb-[25px] mb-[19px]'>
        <Image
          className='sm:w-[175px] w-[144px] sm:h-[171px] h-[141px]'
          alt=' Buying for a team or institution?'
          src={books}
          width={175}
          height={171}
        />
      </div>
      <ButtonDefault
        onClick={() =>
          window.open('https://go.zebralearn.com/inquiry-form', '_blank')
        }
        size={0}
        className='sm:py-3 py-[7px] px-8 sm:text-base text-sm/6 w-full sm:rounded-xl rounded-lg'
        variant={ButtonVariants.PRIMARY}
      >
        Request Bulk Pricing
      </ButtonDefault>
    </div>
  );
};
export const Item3: FC<Props3> = ({ order }) => {
  const hasDigitalBook = order?.orderDetails.some(
    (detail) => detail.book_type === 'digital',
  );
  return (
    <div className='bg-cardBg px-10 sm:pt-[51px] pt-[56px] sm:pb-5 pb-[56px] rounded-2xl flex flex-col items-center'>
      <div className='flex flex-col items-center sm:mb-[25px]'>
        <p className='sm:text-2xl text-xl/8 text-center font-bold text-white mx-2 mb-1.5'>
          Thank You for Choosing ZebraLearn to Learn Better
        </p>
        <p className='sm:text-base text-sm/6 text-grayZl-500 text-center text-balance sm:mb-10 mb-7'>
          Digital access unlocks instantly for prepaid orders, and after
          delivery for COD
        </p>
        <Link href="/library" className='w-full'>
          <ButtonDefault
            size={0}
            className={twMerge(
              'sm:py-3 py-[7px] px-8 sm:text-base text-sm/6 w-full sm:rounded-xl rounded-lg  sm:mb-4 mb-3',
              hasDigitalBook ? 'visible' : 'invisible',
            )}
            variant={ButtonVariants.PRIMARY}
          >
            Start Learning
          </ButtonDefault>
        </Link>
        <Link href="/" className='w-full'>
          <ButtonDefault
            size={0}
            className='sm:py-3 py-[7px] px-8 sm:text-base text-sm/6 w-full sm:rounded-xl rounded-lg border border-primary text-primary sm:mb-6 mb-[18px]'
            variant={ButtonVariants.UNSTYLED}
          >
            Explore More Books
          </ButtonDefault>
        </Link>
        <div className='flex items-center justify-center gap-2 w-full sm:mb-5 mb-2'>
          <div className='flex-1 h-px bg-grayZl-800 rounded-full sm:ms-16' />
          <p className='sm:text-base text-sm/6 text-grayZl-500'>or</p>
          <div className='flex-1 h-px bg-grayZl-800 rounded-full sm:me-16' />
        </div>
        <Link href="/my-orders">
          <p className='text-white font-medium sm:text-base text-sm leading-8 underline'>
            Go to My Orders
          </p>
        </Link>
      </div>
    </div>
  );
};
